module.exports = __webpack_public_path__ + "static/img/ziranzhibao.0c3f5e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/ziranzhibao.jpg
// module id = GNVm
// module chunks = 0